import { Box, Chip } from '@mui/material';
import CloseIcon from 'mdi-react/CloseIcon';
import { arrayOf, func, string } from 'prop-types';
import React from 'react';

const TagList = ({ tags = [], onDelete }) => (
  <Box sx={{ pt: '5px' }}>
    {tags.map(tag => (
      <Chip
        label={tag}
        key={tag}
        deleteIcon={<CloseIcon />}
        sx={{
          height: 35,
          borderRadius: '5px',
          backgroundColor: 'secondary.ultraLight',
          mr: '5px',
          mb: '10px',
        }}
        onDelete={onDelete(tag)}
      />
    ))}
  </Box>
);
TagList.propTypes = {
  onDelete: func.isRequired,
  tags: arrayOf(string),
};

export default TagList;
